var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueShowdown',_vm._b({staticClass:"Markdown",class:{ hasStyles: _vm.hasStyles },attrs:{"markdown":_vm.markdown}},'VueShowdown',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }